<template>
  <div class="hello">
    <van-nav-bar v-if="isWx==1" left-arrow @click-left="onClickLeft" fixed>
      <slot slot="title" name="title">{{examname}}</slot>
    </van-nav-bar>
    <van-nav-bar v-else fixed>
      <slot slot="title" name="title">{{examname}}</slot>
    </van-nav-bar>
    <div class="header-tips">共{{num}}道题（选做），最少需要做4道题，做的越多结果越精准！</div>
    <div class="subject">
      <div class="subject-list">
        <div class="subject-content">
          <van-checkbox-group  v-for="(data,i) in list" :key="i" v-model="data.id">
            <div class="subject-box">
              <div class="subject-title">{{i+1}}、{{data.exam_main}}</div>
              <div class="subject-list" v-for="(item,j) in data.exam_select" :key="j">
                <van-checkbox :name="item.select_no" shape="square">{{item.select_no}}、{{item.select_content}}</van-checkbox>
              </div>
            </div>
          </van-checkbox-group>
        </div>
        <div class="subject-button">
          <div class="button" @click="submit">提交</div>
        </div>
      </div>
    </div>
    <van-dialog v-model="show" :title="examname" cancelButtonText="再次评测" confirmButtonText="我要测" show-cancel-button @confirm="confirm" @cancel="cancel">
        <p class="msgtitle">根据诊断结果可能是以下疾病</p>
        <ul class="msgbox">
          <li class="msglist" v-for="(item,i) in content" :key="i">{{i+1}}、{{item}}</li>
          <li class="msgwar" v-if="content.length <= 0">没有对应疾病，可再次评测，建议详细解答！</li>
        </ul>
    </van-dialog>
  </div>
</template>

<script>
import wx from 'weixin-js-sdk'
import { diseaseexam, diseaseexam1, answerdisease } from '@/api/resetApi.js'
export default {
  name: 'subjectlist',
  data(){
    return{
      show: false,
      browser: {
        trident: navigator.userAgent.indexOf('Trident') > -1, //IE内核
        presto: navigator.userAgent.indexOf('Presto') > -1, //opera内核
        webKit: navigator.userAgent.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
        gecko: navigator.userAgent.indexOf('Gecko') > -1 && navigator.userAgent.indexOf('KHTML') == -1, //火狐内核
        mobile: !!navigator.userAgent.match(/AppleWebKit.*Mobile.*/) || !!navigator.userAgent.match(/AppleWebKit/), //是否为移动终端
        ios: !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
        android: navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Linux') > -1, //android终端或者uc浏览器
        iPhone: navigator.userAgent.indexOf('iPhone') > -1 || navigator.userAgent.indexOf('Mac') > -1, //是否为iPhone或者QQHD浏览器
        iPad: navigator.userAgent.indexOf('iPad') > -1, //是否iPad
        webApp: navigator.userAgent.indexOf('Safari') == -1 //是否web应该程序，没有头部与底部
      },
      user_id: '',
      examid: '',
      examname: '',
      num: '',
      list: [],
      test: [],
      content: [],
      isWx: 1,
    }
  },
  created(){
    this.user_id = this.$route.query.user_id
    this.examid = parseInt(this.$route.query.examid)
    const ua = window.navigator.userAgent.toLowerCase();
    if(ua.indexOf('micromessenger') == -1) {
      this.isWx = 1
    }else{
      this.isWx = 2
    }
    this.getaccessstatus()
    this.gettitle()
  },
  methods: {
    // 提交判断是否做了4道题以上
    submit() {
      let num = 0
      let str = '';
      let that = this
      let reg = /,$/gi;
      if (!this.user_id) {
        this.goLogins();
        return;
      }
      for (let i=0; i<that.list.length; i++) {
        if (that.list[i].id !== undefined && that.list[i].id.length > 0) {
          num = num+1;
          str += '"' + (i+1) + '":"' + that.list[i].id.toString().replace(/,/g,'') + '",'
        }
      }
      if (num >= 4) {
        str = str.replace(reg,"");
        this.test = `{` + str + `}`
        console.log('str',str)
        console.log('test',eval("("+this.test+")"))
        this.addsubject()
      } else {
        this.$createToast({
          txt: '最少需要做4道题',
          type: 'error'
        }).show()
      }
      console.log('num',num)
      num = 0
    },
    // 提交接口
    async addsubject() {
      let data = {
        user_id: this.user_id,
        exam_cate_id: this.examid,
        answer: eval("("+this.test+")")
      }
      const res = await answerdisease(data)
      try {
        if (res.data.code === 1) {
          console.log(res)
          this.show = true
          this.content = res.data.data
          console.log('content=',this.content)
        } else {
          this.$createToast({
            txt: res.data.msg,
            type: 'error'
          }).show()
        }
      } catch (error) {}
    },
    // 获取题目
    async gettitle() {
      let that = this
      const res = await diseaseexam()
      try {
        if (res.data.code === 1) {
          let num = that.examid
          for (let i=0; i<res.data.data.length; i++ ) {
            console.log('num='+num)
            if (res.data.data[i].exam_cate_id == that.examid) {
              that.diseaseexam()
              that.examname = res.data.data[i].examination_name
              return
            }
          }
        } else {
          that.$createToast({
            txt: res.data.msg,
            type: 'error'
          }).show()
        }
      } catch (error) {}
    },
    // 获取题目列表
    async diseaseexam() {
      let data = new URLSearchParams();
      data.append('exam_cate_id',this.examid)
      const res = await diseaseexam(data)
      console.log('resqqqqqq',res)
      try {
        if (res.data.code === 1) {
          this.num = res.data.data.length;
          this.list = res.data.data;
          console.log('列表',this.list)
        } else {
          this.$createToast({
            txt: res.data.msg,
            type: 'error'
          }).show()
        }
      } catch (error) {}
    },
    // 浏览记录
    getaccessstatus() {
      let data = {
        user_id: this.user_id,
        page_type: "home"
      }
      this.$store.dispatch('report/getaccessstatus', data)
    },
    // 我要测
    confirm() {
      const ua = window.navigator.userAgent.toLowerCase();
      if(ua.indexOf('micromessenger') == -1) {
        this.goBack()
      }else{
        this.$router.back(-1)
      }
      console.log('我要测')
    },
    // 再次评测
    cancel() {
      let that = this
      for (let i=0; i<that.list.length; i++) {
        if (that.list[i].id !== undefined && that.list[i].id.length > 0) {
          that.list[i].id = []
        }
      }
      console.log('清空',that.list)
      console.log('再次评测')
    },
    // 返回APP
    goBack(){
      if (this.browser.android) {
        ZKAPP.evaluating();
      }else {
        window.webkit.messageHandlers.evaluating.postMessage({name: 'zhangyutang', age: 12});
      }
    },
    // 返回APP登录
    goLogins(){
      if (this.browser.android) {
        ZKAPP.goLogin();
      }else {
        window.webkit.messageHandlers.goLogin.postMessage({name: 'zhangyutang', age: 12});
      }
    },
    onClickLeft() {
      this.$router.back(-1)
      console.log('返回')
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.van-checkbox {
  text-align: left;
}
.header-tips {
  padding-top: 46px;
  height: 0.24rem;
  line-height: 0.24rem;
  background:rgba(254,235,230,1);
  text-align: center;
  font-size: 0.12rem;
  color: #EA4747
}
.subject {
  padding: 15px;
  background: #388BEB;
  .subject-list {
    background:#fff;
    border-radius:16px;
    .subject-content {
      .subject-box {
        .subject-title {
          padding: 15px;
          text-align: left;
          font-size: 14px;
          color: #181818;
        }
        .subject-list {
          padding: 0 15px 10px;
          font-size: 14px;
        }
      }
    }
    .subject-button {
      padding: 20px;
      .button {
        width:100%;
        height: 40px;
        line-height: 40px;
        background:rgba(245,166,35,1);
        border-radius: 20px;
        text-align: center;
        font-size: 14px;
        font-weight:600;
        color:#fff;
      }
    }
  }
}
.msgtitle {
  height:22px;
  font-size:14px;
  font-weight:400;
  color:rgba(155,155,155,1);
  line-height:22px;
  text-align: center;
  padding-bottom:20px;
}
.msgbox {
  text-align: left;
  .msglist {
    display: inline-block;
    padding-bottom:10px;
    margin-left:10px;
    font-size:12px;
    font-weight:500;
    color:rgba(84,138,236,1);
  }
  .msgwar {
    text-align: center;
    padding-bottom:10px;
    font-size:12px;
    font-weight:500;
    color:rgba(84,138,236,1);
  }
}
</style>
